/*
 * Module for the batch member detail view
*/

rs.module("content/employer/reporting/maintenance/memberdetail",

    ["controls/components/event-banner", "common/lrs-scroll"],

    function (eventBanner, lrsScroll) {

        //
        // Initialize
        //
        function initialize(jsSelectors, backendUrls, grids, batchRejectedOrInProgress, memberIsPostedOrDeleted) {

            // this bool will be set to true on the click event of the delete button in each grid row
            // that event will fire before the selectionChanged() event, which will subsequently read this variable to know if the delete link was clicked
            // after reading the value of the variable it will be reset to false 
            var forDelete = false;

            // Set forDelete variable when delete link is clicked
            $.js(jsSelectors.deleteLink, { multiple: true, required: false }).click(function () { forDelete = true });

            // Loop through grids and hook up click event on each one
            for (let grid in grids) {

                grids[grid].rowClicked(function (values, rows) {

                    // When a row is clicked in one of the grids we want to clear the selections in all of the other grids
                    _clearGridSelections({ exceptFor: this });

                    // Load the detail for the selected row
                    _loadDetail(
                        this.agGridApi.pg.gridOptions.context.detailType,
                        values[0],
                        forDelete
                    );

                    // reset forDelete
                    forDelete = false;
                });
            }

            // When an add link is clicked, make the backend call to get an empty editor template
            $.js(jsSelectors.addLink, { multiple: true }).click(function () {
                _clearGridSelections();

                // Load the detail
                _loadDetail(
                    $(this).data("detailtype"),
                    $(this).data("detailkey"),
                    false
                );
            });

            //
            // Make the backend call to get the detail and display the corresponding edit template 
            //
            function _loadDetail(detailType, detailKey, forDelete) {

                $.get(
                    backendUrls.getDetail,
                    {
                        detailType: detailType,
                        detailKey: detailKey,
                        forDelete: forDelete,
                        batchRejectedOrInProgress: batchRejectedOrInProgress,
                        memberIsPostedOrDeleted: memberIsPostedOrDeleted
                    }
                ).done(function (result) {

                    $.js(jsSelectors.detail).html(result);

                    var form = $.js(jsSelectors.detail).find("form");

                    // Reset validation
                    $.validator.resetValidation(form);

                    eventBanner.removeAllMessages();

                    // after rendering the editor template, intialize it for scrolling
                    lrsScroll.initializeScroll($.js(jsSelectors.detail).find(".lrs-scroll"));
                });
            }

            //
            // Clear all grids, unless specified in 'exceptFor'
            //
            function _clearGridSelections({ exceptFor } = {}) {
                
                // Loop through all of the grids to clear them
                for (let grid in grids) {

                    // If a grid was passed in as the exceptFor argument, we want to skip it and not clear its value.
                    // Else clear the selected value for all other grids
                    if (!exceptFor || exceptFor != grids[grid]) {
                        grids[grid].selectedValues = null;
                    }
                }
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);